import React, {useEffect} from 'react';
import ProfitGraph from "./components/profit-graph/profit-graph.jsx";

function ProfitPage() {

    return (
        <div>

            <ProfitGraph/>

        </div>
    );
}

export default ProfitPage;
